var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.134 12.667c-.459 0-.83-.414-.83-.924v-3.87c-3.53 1.8-5.958 5.514-5.958 9.794 0 6.037 4.833 10.95 10.773 10.95h7.646v-2.165l-6.552-5.014a3.797 3.797 0 0 1-1.094.162c-2.134 0-3.87-1.765-3.87-3.933 0-2.169 1.736-3.934 3.87-3.934.5 0 .995.1 1.457.291l5.25-4.93a10.583 10.583 0 0 0-4.972-2.237v2.915c0 .416-.372.754-.83.754-.459 0-.83-.338-.83-.754V6.717h-.075c-1.098 0-2.157.167-3.156.479v4.547c0 .51-.372.924-.83.924zm4.06-8.333h-.075c-1.088 0-2.145.134-3.156.39v-2.8c0-.51-.372-.924-.83-.924-.459 0-.83.413-.83.923v3.34C7.444 7.22 4 12.044 4 17.668c0 7.279 5.77 13.211 12.906 13.327V31H27.11v-5.737L20.233 20a3.953 3.953 0 0 0 .757-2.333c-.001-.772-.222-1.492-.601-2.1l2.506-2.356.199.185a6.166 6.166 0 0 1 1.248 1.602 5.85 5.85 0 0 1 .7 2.785c0 1.597-.643 3.109-1.81 4.256l1.584 1.462c1.57-1.54 2.433-3.572 2.433-5.718 0-2.24-.93-4.334-2.618-5.894l-.722.708-.148-.15 3.488-3.34-.854-.867c-2.064-2.1-4.695-3.412-7.541-3.792V1.754c0-.417-.372-.754-.83-.754-.459 0-.83.337-.83.754v2.58zm-1.6 13.333c0 .854.684 1.55 1.525 1.55.84 0 1.524-.696 1.524-1.55 0-.855-.684-1.55-1.525-1.55-.842 0-1.526.695-1.526 1.55z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtc);
export default __webpack_public_path__ + "static/media/GTC.7dacfd2a2e1c08e769acc64fac0c6ce3.svg";
export { ForwardRef as ReactComponent };